import { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { IResponseData } from '@/core/interfaces/common'
import { cn } from '@bem-react/classname'

import { TransactionResponse } from '../../store/OrdersInterface'
import './OrderOperations.scss'

interface IOrderOperationsProps {
  className?: string
  orders?: IResponseData<TransactionResponse[]> | null
}

const cnOrderOperations = cn('OrderOperations')
const cnTable = cn('Table')

export const OrderOperations: FC<IOrderOperationsProps> = ({
  className,
  orders,
}) => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const [data, setData] = useState<TransactionResponse[]>([])

  useEffect(() => {
    if (orders && orders.data.length > 0) {
      setData(orders.data)
    }
  }, [orders])

  return (
    <div className={cnOrderOperations(null, [className])}>
      <table className={cnTable()}>
        <thead>
          <tr className={cnTable('row')}>
            <th className={cnTable('th')}> {t('orders-label-1')}</th>
            <th className={cnTable('th')}> {t('orders-label-2')}</th>
            <th className={cnTable('th')}> {t('orders-label-3')}</th>
            <th className={cnTable('th')}> {t('orders-label-4')}</th>
            <th className={cnTable('th')}> {t('orders-label-5')}</th>
          </tr>
        </thead>
        <tbody>
          {data.map(el => (
            <tr
              key={el.invoice_id}
              className={cnTable('row', { click: true })}
              onClick={() => navigate(`/c/orders/${el.invoice_id}`)}
            >
              <td className={cnTable('td')}>{el.id}</td>
              <td className={cnTable('td')}>
                <div
                  className={cnOrderOperations('direction', {
                    new: el.status.name.toLowerCase() === 'new',
                    canceled: el.status.name.toLowerCase() === 'cancel',
                    completed: el.status.name.toLowerCase() === 'completed',
                    process: el.status.name.toLowerCase() === 'process',
                  })}
                >
                  {t(`orders-status-${el.status.name.toLowerCase()}`)}
                </div>
              </td>
              <td className={cnTable('td')}>
                {t(`orders-method-${el.payment_method.toLowerCase()}`)}
              </td>
              <td className={cnTable('td')}>
                <div className={cnOrderOperations('date')}>{el.date}</div>
                <div className={cnOrderOperations('time')}>{el.time}</div>
              </td>
              <td className={cnTable('td')}>
                <div className={cnOrderOperations('date')}>
                  {parseFloat(el.sum_pay)} {el.from}
                </div>
                <div className={cnOrderOperations('time')}>
                  {parseFloat(el.sum_buy)} {el.to}
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
